/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const r4ReportApiList = {
  getSettleSumInfo: '/pay/acquire/settle/sum/info', // 获取结算汇总金额
  getRefundSumInfo: '/pay/acquire/refund/sum/info', // 获取退款金额汇总
  getSupplierId: '/manage/shop/shop/get', // 获取供应商id
  getPayedSettle: '/pay/list/payed/settle', // 获取已支付结算单
  getPayedSettleDetail: '/pay/get/payed/settle/detail', // 获取已支付明细
  getBillOrder: '/pay/get/no/pay/supplier/bill/order', // 待处理订单
  getUnsettledOrder: '/pay/get/unsettled/pay/supplier/bill', // 待结算订单
  exportPayedSettleDetail: '/pay/export/payed/settle/detail', // 导出已支付明细
  exportUnPayedSettleDetail: '/pay/export/unpaid/settle/detail', // 导出未支付明细
  getDeductedRefund: '/pay/list/deducted/refund', // 获取已退货列表
  getDeductedRefundDetail: '/pay/get/deducted/refund/settle/detail', // 获取已退货明细
  getUnDeductedRefundDetail: '/pay/list/unDeducted/refund', // 获取未扣款明细
  exportDeductedRefundDetail: '/pay/export/deducted/refund/detail', // 导出已扣款明细
  exportUnDeductedRefundDetail: '/pay/export/unDeducted/refund/detail', // 导出未扣款明细
  getDeliverGoodsTotalAmount: '/system/payment/delivergoodstotalamount', // 获取发货总金额
  getDeliverGoodsList: '/system/payment/delivergoodslist', // 获取发货列表
  getLegalInfo: '/pay/legal-info', // 获取商户信息
}
export default r4ReportApiList



// WEBPACK FOOTER //
// ./src/service/basic/r4ReportApiList.js